import { Box, Typography } from "@mui/material";
import {
  MRT_PaginationState,
  MRT_RowSelectionState,
} from "material-react-table";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useGetMailBoxEmails from "../data-access/useGetMailBoxEmails";
import useGetMailBoxParams from "../data-access/useGetMailBoxParams";
import { TMailBoxFilterValues } from "../types";
import MailBoxFilters from "./ui/MailBoxFilters";
import MailBoxResults from "./ui/MailBoxResults";

function Mailbox() {
  const { t } = useTranslation();
  const { data: mailboxParams, isLoading: isLoadingParams } =
    useGetMailBoxParams();
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [filters, setFilters] = useState<TMailBoxFilterValues>({
    fromDate: undefined,
    toDate: undefined,
    messageTypeId: undefined,
    messageReadTypeId: undefined,
  });
  const { data: emails, isLoading: isLoadingEmails } = useGetMailBoxEmails({
    ...filters,
    ...pagination,
  });
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        width: "80vw",
        mx: "auto",
      }}
    >
      <Typography variant="h5">{t("Θυρίδα μηνυμάτων")}</Typography>
      <Typography variant="h6">
        {t(
          "Στην οθόνη αυτή εμφανίζονται όλα τα email που σας έχουν αποσταλεί.",
        )}
      </Typography>
      <MailBoxFilters
        mailboxParams={mailboxParams}
        isLoadingParams={isLoadingParams}
        setFilters={setFilters}
      />
      <MailBoxResults
        loading={isLoadingEmails}
        results={emails}
        setPaginationModel={setPagination}
        pagination={pagination}
        setRowSelectionModel={setRowSelection}
        rowSelection={rowSelection}
      />
    </Box>
  );
}

export default Mailbox;
